// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"q1-z","categoryName":"r1-z","categoryImage":"s1-z","categoryContent":"t1-z","bottomAligned":"u1-z"};